export const locales = ["RO", "EN"] as const;

export type ErrorTranslations = Record<
  string,
  {
    [locale in (typeof locales)[number]]: string;
  }
>;
